/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RankRequest
 */
export interface RankRequest {
    /**
     * 
     * @type {string}
     * @memberof RankRequest
     */
    after?: string;
    /**
     * 
     * @type {string}
     * @memberof RankRequest
     */
    before?: string;
}

/**
 * Check if a given object implements the RankRequest interface.
 */
export function instanceOfRankRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RankRequestFromJSON(json: any): RankRequest {
    return RankRequestFromJSONTyped(json, false);
}

export function RankRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RankRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'after': !exists(json, 'after') ? undefined : json['after'],
        'before': !exists(json, 'before') ? undefined : json['before'],
    };
}

export function RankRequestToJSON(value?: RankRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'after': value.after,
        'before': value.before,
    };
}

